import {AxiosInstance} from "axios";
import {apiHost} from "../../shared/technical/rest/restApi";
import {handleSuccessResponse} from "../../shared/technical/rest/errorHandling";
import {User} from "./User";

export function getCurrentAccount(axios: AxiosInstance): Promise<User> {
  const baseUri = apiHost + '/account';
  return axios.get(baseUri).then(handleSuccessResponse);
}
